import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["announcement", "tokens", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './UtilityNav.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var UtilityNavBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _announcement$descrip;

  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var description = typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string" ? announcement.description : announcement === null || announcement === void 0 ? void 0 : (_announcement$descrip = announcement.description) === null || _announcement$descrip === void 0 ? void 0 : _announcement$descrip.md;
  return _jsx(views.Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: _jsxs(views.Container, {
      children: [_jsx(views.DescriptionSlot, {
        children: announcement && _jsxs(_Fragment, {
          children: [_jsx(views.Description, {
            variant: "buttonSmall",
            children: description
          }), _jsx(views.CtaLink, {
            tokens: _objectSpread({}, tokens.buttonText),
            size: "small",
            href: announcement.ctaLink,
            hover: true,
            children: announcement.ctaTitle
          })]
        })
      }), _jsx(views.AsideSlot, {
        children: children
      })]
    })
  }));
});
var UtilityNav = withDesignTokens(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.brand.darkAcai[700],
      buttonText: {
        textColor: theme.palette.neutrals.white[100],
        hoverColor: theme.palette.brand.darkAcai[200]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.brand.darkAcai[700],
      buttonText: {
        textColor: theme.palette.neutrals.white[100],
        hoverColor: theme.palette.brand.darkAcai[200]
      }
    };
  }
});
export default UtilityNav;